"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilterStateKeyEnum;
(function (FilterStateKeyEnum) {
    FilterStateKeyEnum["availability"] = "availability";
    FilterStateKeyEnum["body"] = "body";
    FilterStateKeyEnum["equipment"] = "equipment";
    FilterStateKeyEnum["extra"] = "extra";
    FilterStateKeyEnum["fuel"] = "fuel";
    FilterStateKeyEnum["inquiryType"] = "inquiryType";
    FilterStateKeyEnum["contractLength"] = "contractLength";
    FilterStateKeyEnum["winterTires"] = "winterTires";
    FilterStateKeyEnum["make"] = "make";
    FilterStateKeyEnum["mileage"] = "mileage";
    FilterStateKeyEnum["model"] = "model";
    FilterStateKeyEnum["offers"] = "offers";
})(FilterStateKeyEnum || (FilterStateKeyEnum = {}));
exports.default = FilterStateKeyEnum;
